module.exports = __webpack_public_path__ + "static/media/post_1.fae0e57f.png";